import { Button, ButtonProps } from "@material-ui/core"
import { ResourceAbility } from "libs/security/authorization"
import React, { useCallback } from "react";
import AddIcon from "@material-ui/icons/Add";
import { FormattedMessage } from "react-intl";
import Dialog, { useDialogProps } from "legacy-components/dialog/Dialog";
import { AppResponse } from "libs/resources/identity/applications/application-form/ApplicationBasicForm";
import ResourceAppBasicForm from "libs/resources/identity/applications/application-form/ResourceAppBasicForm";
import Authorizer from "modus/components/authorizer/Authorizer";

interface ApplicationCreationPageProps extends ButtonProps {
    onSuccess: (app: AppResponse) =>void;
}
export const ApplicationCreationPage:React.FC<ApplicationCreationPageProps> = ({onSuccess, ...props}) => {

    const {open: openAppCreate, toggle} = useDialogProps();
   

    const toApplicationCreate = useCallback(() => {
        toggle();
    }, [toggle]);

    return (
        <>
        <ResourceAbility can="create" resource={({ Application }) => [
            Application.create.environment["trimble-prod"],
            Application.create.environment["trimble-pre-prod"]
        ]}>
            <Authorizer resource="applications" action="create">
            <Button startIcon={<AddIcon />} onClick={toApplicationCreate} variant="contained" color="primary" {...props}>
                <FormattedMessage defaultMessage="Create New Application" />
            </Button>
            </Authorizer>
        </ResourceAbility>
         <Dialog open={openAppCreate} title="Create New Application" onClose={toggle} maxWidth="md" >
                <div>
                    <ResourceAppBasicForm onCancel={toggle} onSuccess={onSuccess}></ResourceAppBasicForm>
                </div>
            </Dialog>
        </>
    )
}